import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import component from './component';
import { getWorkflowState } from '../../selectors/machine';

export const mapStateToProps = createStructuredSelector({
  workflowState: getWorkflowState,
});

const enhance = connect(mapStateToProps, null);

export default enhance(component);
